import React from 'react';
import { useCustomerContext } from '../../../contexts/CustomerContext';
import { getLabel } from '../../../hooks/siteData';
import { navigate } from 'gatsby';

const COUNTRY_SELECT_PATH = '/countrySelect/';

export default function CurrencySwitcher() {

    const { customer, setCustomer } = useCustomerContext();

    if (customer.token && !customer.email.endsWith('nanoporetech.com')) return null;

    function activateCountrySelect(e) {
        e.preventDefault();
        setCustomer({...customer, intended_store_view: ''});
        navigate(COUNTRY_SELECT_PATH);
    }

    return (
        <a href={COUNTRY_SELECT_PATH} onClick={activateCountrySelect}>Change store ({getLabel()})</a>
    );
}
